module.exports = __webpack_public_path__ + "assets/outbrain.afe20196.svg";